import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { parseNewPaymentKind, type NewPaymentKind } from '@/features/billing/billing-shared';
import { PaymentMethodCreatePage } from '@/features/billing/payment-methods-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Ajouter un moyen de paiement (lot L01) : mandat SEPA ou virement ; le choix vit dans l'URL (`?kind=`). */
export const Route = createFileRoute('/$tenant/billing/payment-methods/new')({
  validateSearch: (search: Record<string, unknown>): { kind: NewPaymentKind } => ({
    kind: parseNewPaymentKind(search['kind']),
  }),
  component: NewPaymentMethodRoute,
});

function NewPaymentMethodRoute() {
  const { tenant } = Route.useParams();
  const { kind } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="paymentMethods"
      crumbs={[{ label: t('nav.items.paymentMethods') }, { label: t('billing.paymentMethods.newTitle') }]}
    >
      <PaymentMethodCreatePage
        tenantId={tenant}
        kind={kind}
        onKindChange={(next) => void navigate({ search: { kind: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
